import { render, staticRenderFns } from "./RemnantPastOmc.vue?vue&type=template&id=a40958d0"
import script from "./RemnantPastOmc.vue?vue&type=script&lang=js"
export * from "./RemnantPastOmc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports